import React from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { MenuItemLink, getResources, MenuProps } from 'react-admin';
import {
  ViewList as ViewListIcon,
  Business as BusinessIcon,
  CalendarToday as CalendarTodayIcon,
} from '@material-ui/icons';
import { Resources, useAccessibleResources } from '../lib/react-admin-loopback';

const CustomMenu = (props: MenuProps) => {
  const { onMenuClick, logout } = props;
  const isXSmall = useMediaQuery((theme: any) => theme.breakpoints.down('xs'));
  const open = useSelector((state: any) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);

  const accResList = useAccessibleResources() as string[];
console.log(accResList)
  return (
    <div>
      <MenuItemLink
        to='/dashboard'
        primaryText='대시보드'
        leftIcon={<BusinessIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to='/schedules'
        primaryText='전체 스케쥴 & 큐레이션'
        leftIcon={<CalendarTodayIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      {resources.map((resource) => {
        const showMenu = resource.options.label && (
          publicResources.includes(resource.name) ||
          accResList.includes(mapResNameToResource(resource.name))
        );

        return showMenu ? ( 
          <MenuItemLink
            key={resource.name}
            to={`/${resource.name}`}
            primaryText={
              (resource.options && resource.options.label) || resource.name
            }
            leftIcon={resource.icon ? <resource.icon /> : <ViewListIcon />}
          />
        ) : null;

      })}
      {/* <MenuItemLink
        to='/order/settlement/customer'
        primaryText='고객사 주문 정산'
        leftIcon={<ViewListIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to='/order/settlement/supplier'
        primaryText='공급사 주문 정산'
        leftIcon={<ViewListIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      /> */}
      {accResList.includes(Resources.SupplierOrders) && 
      <MenuItemLink
        to='/supplier/settlement'
        primaryText='공급자 정산 상세'
        leftIcon={<ViewListIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />}
      {accResList.includes(Resources.CustomerOrders) &&
      <MenuItemLink
        to='/customer/settlement'
        primaryText='고객사 정산 상세'
        leftIcon={<ViewListIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />}
      {isXSmall && logout}
    </div>
  );
};

export default CustomMenu;

/// helpers 

const publicResources = [
  'usermenus/reviews', 'files', 'cs', 'menusurveys', 
];

const mapResNameToResource = (name: any): string => {
  switch (name) {
    case 'customers':
      return Resources.Customer;
    case 'suppliers':
      return Resources.Supplier;
    case 'menus':
      return Resources.Menu;
    case 'cm-stlist':
      return Resources.CustomerOrders;
    case 'cm-tilist': 
      return Resources.CustomerBill;
    case 'sp-stlist':
      return Resources.SupplierOrders;
    case 'sp-crlist':
      return Resources.SupplierBill;
    default:
      return name;
  }
}
